import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
const CryptoJS = require("crypto-js");

var Logout = () => {

    let navigate = useNavigate();
    const { state } = useLocation();


    useEffect(() => {
        let msg = "";
        if (state !== undefined && state?.success !== "") {
            msg = state?.success;
        }
        window.localStorage.clear();
        navigate("/", {
            state: {
                success: msg
            }
        });
    }, []);


    return (
        <>Logout....</>
    );
}


export default Logout;